module.exports = __webpack_public_path__ + "static/media/PER.66e02076.png";